var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86627 10.1925C2.1193 8.44554 2.1193 5.61323 3.86627 3.86627C5.61323 2.1193 8.44554 2.1193 10.1925 3.86627L20.1337 13.8075C21.8807 15.5545 21.8807 18.3868 20.1337 20.1337C18.3868 21.8807 15.5545 21.8807 13.8075 20.1337L8.61024 14.9365C7.98663 14.3129 7.98663 13.3007 8.61024 12.6771C9.23386 12.0535 10.246 12.0535 10.8696 12.6771L15.6136 17.4225C16.1133 17.9208 16.9228 17.9208 17.4225 17.4225C17.9208 16.9228 17.9208 16.1133 17.4225 15.6136L12.6771 10.8696C11.0554 9.24793 8.42442 9.24793 6.80275 10.8696C5.18107 12.4913 5.18107 15.1223 6.80275 16.744L12 21.9412C14.745 24.6863 19.1962 24.6863 21.9412 21.9412C24.6863 19.1962 24.6863 14.745 21.9412 12L12 2.05877C9.25497 -0.686257 4.8038 -0.686257 2.05877 2.05877C-0.686257 4.8038 -0.686257 9.25497 2.05877 12L2.50924 12.4505C3.00897 12.9502 3.8184 12.9502 4.31814 12.4505C4.81647 11.9521 4.81647 11.1427 4.31814 10.643L3.86627 10.1925Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocument);
export default __webpack_public_path__ + "static/media/uploadDocument.09ef38613d78f66813c4f6fa4f26f38c.svg";
export { ForwardRef as ReactComponent };